import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  KEY_DOWN_COMMAND,
  COMMAND_PRIORITY_LOW,
  $getSelection,
  $isRangeSelection,
  $createParagraphNode,
} from 'lexical';
import { useEffect } from 'react';

export function CodeBlockExitPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      editor.registerCommand(
        KEY_DOWN_COMMAND,
        (event) => {
          const keyboardEvent = event as KeyboardEvent;
          if (keyboardEvent.key !== 'Enter') return false;

          let inCode = false;
          let isAtEnd = false;
          let codeElement: any = null;

          editor.getEditorState().read(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
              let node: any = selection.anchor.getNode();
              while (node) {
                if (node.getType?.() === 'code') {
                  inCode = true;
                  codeElement = node;
                  break;
                }
                node = node.getParent?.();
              }

              if (inCode) {
                let anchor: any = selection.anchor.getNode();
                isAtEnd = true;
                if (anchor.getTextContentSize && typeof selection.anchor.offset === 'number') {
                  if (selection.anchor.offset !== anchor.getTextContentSize()) isAtEnd = false;
                }
                while (anchor && anchor !== codeElement) {
                  if (anchor.getNextSibling && anchor.getNextSibling()) {
                    isAtEnd = false;
                    break;
                  }
                  anchor = anchor.getParent?.();
                }
              }
            }
          });

          if (!inCode) return false;

          if (keyboardEvent.shiftKey) {
            return false;
          }

          if (isAtEnd) {
            keyboardEvent.preventDefault();
            keyboardEvent.stopPropagation();
            editor.update(() => {
              const paragraph = $createParagraphNode();
              codeElement.insertAfter?.(paragraph);
              paragraph.select?.();
            });
            return true;
          }
          return false;
        },
        COMMAND_PRIORITY_LOW,
      ),
    [editor],
  );

  return null;
}
